<template>
  <div>
    <div class="link-button-box">
      <ButtonToNewLoginInfo />
      <ButtonToExamResult />
    </div>
    <div class="login-info">
      <div class="login-info-header">
        <h2 class="login-info-title">発行済みログイン情報</h2>
        <span class="access-date">{{ accessDate }}</span>
        <span class="reget-login-info" @click="getLoginInfo()">
          <img class="reload-icon" :src="reload">
        </span>
        <div class="search-form">
          <label class="search-form-label">受験者名検索</label>
          <input type="text" v-model="search" class="search-form-input">
        </div>
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="login_info_table"
        size="sm"
        align="center"
      />
      <b-table
        id="login_info_table"
        :fields="fields"
        :items="filteredLoginInfo"
        :per-page="perPage"
        :current-page="currentPage"
        small
        striped
        hover
      >
        <template #cell(urlPassword)="data">
          <span :id="'url_password_' + data.index" class="url-password">
            受験用URL: https://codetest.microad.co.jp/exam/login<br>
            パスワード: {{ data.item.applicantPassword }}
          </span>
          <b-button @click="copyToClipboard(data.index)" class="copy-button">
            copy
          </b-button>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="login_info_table"
        size="sm"
        align="center"
      />
    </div>
  </div>
</template>

<script>
import ButtonToExamResult from '@/main/frontend/components/ButtonToExamResult.vue'
import ButtonToNewLoginInfo from '@/main/frontend/components/ButtonToNewLoginInfo.vue'
import reload from '@/main/frontend/assets/reload.png'

export default {
  components: {
    ButtonToExamResult,
    ButtonToNewLoginInfo
  },
  data() {
    return {
      accessDate: null,
      reload: reload,
      search: '',
      perPage: 10,
      currentPage: 1,
      fields: [
        {key: 'applicantName', label: '受験者名'},
        {key: 'applicantPassword', label: 'パスワード'},
        {key: 'port', label: 'ポート番号'},
        {key: 'urlPassword', label: 'メール送付用テンプレ'}
      ],
      loginInfo: [{applicantName: '', applicantPassword: '', port: ''}]
    }
  },
  mounted() {
    this.getLoginInfo()
  },
  computed: {
    rows() {
      return this.filteredLoginInfo.length
    },
    filteredLoginInfo(){
    　return this.loginInfo.filter(item => {
        return item.applicantName.includes(this.search)
    　})
    }
  },
  methods: {
    copyToClipboard(index) {
      const copyText = document.getElementById('url_password_' + index).innerText
      // textarea 内の文章のみ clipboard に copy できそうだから、
      // 一時的に textarea を作成し、copy 終了時に textarea を削除
      const area = document.createElement('textarea')
      area.textContent = copyText
      document.body.appendChild(area)
      area.select()
      document.execCommand('copy')
      document.body.removeChild(area)
    },
    getLoginInfo() {
      // タイムスタンプを生成
      const date = new Date()
      const accessDate = date.getFullYear() + '/' +
        (date.getMonth() + 1) + '/' +
        date.getDate() + ' ' +
        date.getHours() + ':' +
        ('00' + date.getMinutes()).slice(-2)
      this.accessDate = accessDate

      // API からログイン情報を取得
      this.$axios
        .get('/api/login_info/index')
        .then((response) => (this.loginInfo = response.data))
    }
  }
}
</script>

<style scoped>
.login-info {
  margin: 15px 15px 0;
}
.login-info-header {
  overflow: hidden;
}
.login-info-title {
  display: inline-block;
  font-size: 20px;
}
.access-date {
  margin-left: 15px;
}
.reget-login-info {
  border-radius: 3px;
  cursor: pointer;
  display: inline-block;
  margin-left: 8px;
  width: 24px;
}
.reget-login-info:active {
  background-color: #6c757d;
}
.reload-icon {
  margin: 0 0 4px 4px;
  width: 16px;
}
.search-form {
  float: right;
}
.search-form-label {
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem 0 0 0.25rem;
  border-right: 0;
  padding: 0.375rem 0.75rem;
}
.search-form-input {
  border: 1px solid #ced4da;
  border-radius: 0 0.25rem 0.25rem 0;
  padding: 0.375rem 0.75rem;
}
.search-form-input:focus {
  outline: none;
}
.url-password {
  display: block;
  float: left;
  font-size: 12px;
}
.copy-button {
  display: block;
  float: left;
  font-size: 11px;
  margin-left: 10px;
  padding: 2px 3px;
}
</style>
